module.exports = __webpack_public_path__ + "f352a380.svg";